import { createRealtimeTicket, type GencowCtx } from "@gencow/core";

const DEFAULT_REALTIME_TICKET_TTL_SECONDS = 60;

type RouteContext = {
  header(name: string, value: string): void;
  json(body: unknown, status?: number): unknown;
};

type RouteRegistrar = {
  post(path: string, handler: (context: RouteContext) => Promise<unknown> | unknown): void;
};

function readSessionId(user: unknown): string | null {
  if (!user || typeof user !== "object") return null;
  const record = user as Record<string, unknown>;
  const candidates = [record.sessionId, record.session_id, record.sid];
  const sessionId = candidates.find((value): value is string => typeof value === "string" && value.length > 0);
  return sessionId ?? null;
}

export function registerRealtimeTicketRoute(params: {
  app: RouteRegistrar;
  appName: string;
  internalToken: string;
  buildCtx(context: any): GencowCtx;
  ttlSeconds?: number;
}): void {
  params.app.post("/api/realtime/ticket", async (c) => {
    c.header("Cache-Control", "no-store");
    c.header("Pragma", "no-cache");

    const ctx = params.buildCtx(c);
    const user = ctx.auth.getUserIdentity();
    if (!user) {
      return c.json({ error: "Authentication required" }, 401);
    }

    const ttlSeconds = params.ttlSeconds ?? DEFAULT_REALTIME_TICKET_TTL_SECONDS;
    const nowMs = Date.now();
    const ticket = createRealtimeTicket({
      appName: params.appName,
      userId: String(user.id),
      sessionId: readSessionId(user),
      secret: params.internalToken,
      ttlSeconds,
      nowMs,
    });
    return c.json({
      ticket,
      authMode: "authenticated",
      expiresAt: nowMs + ttlSeconds * 1000,
    });
  });
}
